import React from 'react';

import { Color } from '../../types/theme';
import { OverlayContext } from '../../contexts/overlay';
import { useTimer, useTimers } from '../../hooks/use-game-timer';
import { GameDocumentContext } from '../../contexts/game-document';
import { GetTimerObjectById } from '../../utils/game-document/assets';
import { GetResourceValue } from '../../utils/game-document/resources';

export const TimerProgressPill = () => {
  const [overlay, setOverlay] = React.useContext(OverlayContext);
  const [gameDocument] = React.useContext(GameDocumentContext);

  const timerVisibility =
    overlay.timerAssId !== undefined && overlay.timerAssId !== '';

  const theme: Color[] = gameDocument?.theme?.colors ?? [];
  const backgroundColor = theme?.find(
    (x) => x.type === 'Background & Text'
  )?.color;

  const { timers } = useTimers();
  const runningTimers = React.useMemo(
    () => timers.filter((t) => t.status === 'running' || t.status === 'paused'),
    [timers]
  );

  const onChangeTimerView = () => {
    if (runningTimers.length < 2) return;
    const currentTimerIndex = runningTimers.findIndex(
      (t) => t.id === overlay.timerAssId
    );
    const timerLength = runningTimers.length;
    const nextIndex =
      currentTimerIndex === timerLength - 1 ? 0 : currentTimerIndex + 1;

    setOverlay((prev) => ({
      ...prev,
      timerAssId: runningTimers.at(nextIndex)?.id
    }));
  };

  return (
    <div
      className={`progress-pill cursor-pointer ${
        timerVisibility ? '' : 'progress-pil__game-title'
      }`.trim()}
      style={{
        backgroundColor: backgroundColor ?? 'rgb(0,58,100)'
      }}
      onClick={onChangeTimerView}>
      <TimerValue />
    </div>
  );
};

const TimerValue = () => {
  const [overlay] = React.useContext(OverlayContext);
  const [gameDocument] = React.useContext(GameDocumentContext);

  const timerVisibility =
    overlay.timerAssId !== undefined && overlay.timerAssId !== '';

  const theme: Color[] = gameDocument?.theme?.colors ?? [];
  const infoColor = theme?.find((x) => x.type === 'Info')?.color;

  const { timer, formatted, seconds } = useTimer(overlay.timerAssId ?? '');

  const timerTitle = React.useMemo(() => {
    if (!gameDocument.gameDocument || !overlay.timerAssId) return '';

    const selectedTimer = GetTimerObjectById(
      gameDocument.gameDocument,
      overlay.timerAssId
    );

    return GetResourceValue(
      gameDocument.gameDocument,
      selectedTimer?.titleResId!,
      ''
    );
  }, [overlay.timerAssId]);

  const percentage = React.useMemo(
    () => ((seconds * 1000) / (timer?.durationMs ?? 0)) * 100,
    [seconds, timer?.durationMs]
  );

  return (
    <>
      <div
        className={'progress-pill__progress'}
        style={{
          ...(percentage > 0 && {
            backgroundImage: `conic-gradient(${
              infoColor ?? 'rgb(13,197,232)'
            } ${percentage}%, transparent ${percentage}%)`
          })
        }}>
        <img
          id={'game-or-timer-logo'}
          className={'progress-pill__image'}
          src={!overlay.gameLogo ? '/cg-icon-globe.svg' : overlay.gameLogo}
          alt={overlay.gameName}
        />
      </div>
      <div
        className={'d-flex flex-column justify-content-center overflow-hidden'}>
        <div id={'timer-title'} className={'progress-pill__title'}>
          {timerVisibility ? timerTitle : overlay.gameName}
        </div>
        {timerVisibility && (
          <div id={'timer-counter'} className={'progress-pill__subtitle'}>
            {formatted}
          </div>
        )}
      </div>
    </>
  );
};
